export const componentEntityMap = new Map<string, string>([
  ['home', ''],
  ['claim', 'claimId'],
  ['admin', ''],
  ['client', 'clientAccountId'],
])

export const componentDisplayEntityMap = new Map<string, string>([
  ['home', ''],
  ['claim', 'claimNumber'],
  ['admin', ''],
  ['client', 'clientAccountName'],
  ['user', '']
])
